// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"672":"743440e449b74d43f8bd","2326":"8c5b220bf6f482881a90","5787":"8c5b220bf6f482881a90","6547":"8c5b220bf6f482881a90","9689":"8c5b220bf6f482881a90"}[chunkId] + ".css";
};